<template>
    <div class="goods-detail-view" v-if='goodsDetail'>
        <!-- 導航欄 -->
        <van-nav-bar fixed title="商品詳情" left-arrow @click-left="onBack" />
        <!-- 輪播圖 -->
        <van-swipe class="banner" :autoplay="3000">
            <van-swipe-item v-for="(item, index) in goodsDetail.banners" :key="index" class="banner-view">
                <img :src="item.img" />
            </van-swipe-item>
        </van-swipe>
        <!-- 主題內容 -->
        <div class="content-view">
            <!-- 價格 -->
            <div class="price-view">
                <p class="new-price">$ {{goodsDetail.newPrice}}</p>
                <p class="old-price">原價 ${{goodsDetail.oldPrice}}</p>
                <span class="sale-item" v-if="goodsDetail.sale">特價</span>
            </div>
            <!-- 規格 -->
            <div class="standard-view">
                <div class="items">
                    <div v-for="(item,index) in goodsDetail.standardImages" :key="index">
                        <img :src="item.img" :alt="item.color">
                    </div>
                </div>
                <div class="side">
                    <select name="eyes">
                        <option value="左眼">左眼</option>
                        <option value="右眼">右眼</option>
                    </select>
                    <select name="degree">
                        <option v-for="item in goodsDetail.degree" :key="item" :value="item">{{item}}</option>
                    </select>
                </div>
                <van-stepper class="stepper" v-model="number"></van-stepper>
            </div>
            <!-- 描述 -->
            <div class="desc-view">
                <div class="title">
                    <span>自營</span>
                    <p>{{goodsDetail.name}}</p>
                </div>
                <p class="desc">{{goodsDetail.desc}}</p>
            </div>
            <!-- 說明 -->
            <div class="explain-view">
                <span>說明</span>
                <P>{{goodsDetail.explain}}</P>
                <van-icon name="arrow" class="icon"></van-icon>
            </div>
        </div>
        <!-- 商品評價 -->
        <div class="appraise-view">
            <div class="appraise-title">
                <span class="title">商品評價({{goodsDetail.appraise.num}})</span>
                <span class="rate-score">好評 {{goodsDetail.appraise.rateScore}}% <van-icon name="arrow" class="icon"></van-icon></span>
            </div>
            <div class="appraise-content">
                <div class="box" ref="scrollView">
                    <userAppraiseView v-for="(item,index) in goodsDetail.appraise.list" :key="index" :appraise="item"></userAppraiseView>
                </div>
            </div>
        </div>
        <!-- 產品訊息 -->
        <div class="product-view">
            <h3>圖文詳情</h3>
            <h4>產品訊息</h4>
            <table>
                <tr v-for="(item, index) in goodsDetail.productMessage" :key="index">
                    <td>{{item.key}}</td>
                    <td>{{item.value}}</td>
                </tr>
            </table>
        </div>
        <!-- 產品印花 -->
        <div class="product-view">
            <h3>產品印花</h3>
            <div class="product-border" v-for="(item,index) in goodsDetail.productStamp" :key='index'>
                <h4>{{item.stamp}}</h4>
                <p>{{item.text}}</p>
                <img :src="item.img" alt="">
            </div>
        </div>
        <!-- 商品導購 -->
        <van-goods-action>
            <van-goods-action-icon icon="like-o" text="收藏" @click="onCollect" />
            <van-goods-action-icon icon="cart" text="购物车" @click="onCart" />
            <van-goods-action-button type="warning" text="加入购物车" @click="onAddCart" />
            <van-goods-action-button type="danger" text="立即购买" @click="onBuy" />
        </van-goods-action>
    </div>
</template>

<script>
    import { NavBar, Swipe, SwipeItem, Stepper, Icon, GoodsAction, GoodsActionIcon, GoodsActionButton } from 'vant';
    import userAppraiseView from '../userAppraiseView/userAppraiseView.vue';
    export default {
        name: "goodsDetailView",
        components: {
            [NavBar.name]: NavBar,
            [Swipe.name]: Swipe,
            [SwipeItem.name]: SwipeItem,
            [Stepper.name]: Stepper,
            [Icon.name]: Icon,
            userAppraiseView,
            [GoodsAction.name]: GoodsAction,
            [GoodsActionIcon.name]: GoodsActionIcon,
            [GoodsActionButton.name]: GoodsActionButton,
        },
        data() {
            return {
                goodsDetail: null
            }
        },
        methods: {
            onBack: function () {
                this.$store.commit("changeGoodsDetailShow")
            },
            onCollect: function () {
                console.log('Collect')
            },
            onCart: function () {
                console.log('onCart')
            },
            onAddCart: function () {
                console.log('onAddCart:')
            },
            onBuy: function () {
                console.log('onBuy')
            },
        },
        beforeUpdate() {    // 钩子函数
            //確保有DOM已經渲染完成後再去做
            this.$nextTick(function () {
                console.log(this.$refs.userAppraise);
                //this.$refs.userAppraise[0] 組件
                //vm.$el 組件中的根DOM元素
                var userAppraise = this.$refs.userAppraise[0].$el
                //元素寬度
                var width = userAppraise.offsetWidth
                //element.style 內聯樣式
                //getComputedStyle 包括內聯樣式、嵌入樣式、外部樣式
                var computedStyle = getComputedStyle(userAppraise, null)
                //右間距，parseInt去除px
                var marginR = parseInt(computedStyle.marginRight)
                //動態計算
                var temp = this.goodsDetail.appraise.list.length * (width + marginR * 2) + 'px'
                // 设置
                this.$refs.scrollView.style.width = temp;
            });
        },
        created() {
            var that = this;
            this.$ajax.get('/json/goods-detail.json')
                .then(function (response) {
                    that.goodsDetail = response.data;
                })
        },
    };
</script>

<style lang="scss">
    .goods-detail-view {
        padding-top: 45px;
        overflow: auto;
        background-color: #f2f2f2;
        position: fixed;
        left: 0px;
        top: 0%;
        bottom: 0;
        z-index: 99;
        width: 100%;
        padding-bottom: 50px;
        .banner {
            img {
                width: 100%;
            }
        }
        .content-view {
            background-color: white;
            border: 1px #bbb;
            border-left: 0px;
            border-right: 0px;
            border: 2px solid #bbb;
            border-left: 0;
            border-right: 0;
            .price-view {
                height: 40px;
                line-height: 40px;
                .new-price {
                    font-size: 21px;
                    font-weight: 900;
                    margin: 0 20px;
                    color: red;
                    float: left;
                }
                .old-price {
                    float: left;
                    font-size: 12px;
                    color: #7c7c7c;
                    margin-right: 20px;
                    text-decoration: line-through;
                }
                .sale-item {
                    display: inline-block;
                    font-size: 12px;
                    color: white;
                    background: red;
                    width: 30px;
                    height: 18px;
                    line-height: 18px;
                    text-align: center;
                }
            }
        }
        .standard-view {
            overflow: hidden;
            padding: 0 20px;
            .items {
                margin-left: 0px;
                float: left;
                // overflow: hidden;
                width: 225px;
                img {
                    width: 62px;
                    height: 62px;
                    margin-right: 10px;
                    float: left;
                    border: 1px solid black;
                }
            }
            .side select {
                background: white;
                color: black;
                float: left;
                margin-right: 10px;
                border-radius: 5px;
            }
            .stepper {
                display: inline-block;
                margin: 10px 0 0 10px;
            }

            .van-stepper__input,
            .van-stepper__minus,
            .van-stepper__plus {
                border: 1px solid rgb(169, 169, 169);
                background: white;
            }
        }
        .desc-view {
            margin: 15px 0;
            padding: 0 20px;
            border-bottom: 1px solid #bbb;
            .title {
                overflow: hidden;
                margin-bottom: 15px;
                font-weight: 800;
                span {
                    border: 1px solid red;
                    font-size: 12px;
                    text-align: center;
                    padding: 2px 5px;
                    color: red;
                    float: left;
                    margin: 0 13px;
                }
                p {
                    float: left;
                }
            }
            .desc {
                font-size: 12px;
                color: #7c7c7c;
                line-height: 17px;
                padding-bottom: 10px;
            }
        }
        .explain-view {
            margin-bottom: 10px;
            padding: 0 20px 10px 20px;
            overflow: hidden;
            font-size: 12px;

            span {
                font-weight: 800;
                color: black;
                float: left;
                margin-right: 23px;
            }
            p {
                color: #7c7c7c;
                float: left;
            }
            .icon {
                color: #7c7c7c;
                float: right;
            }
        }
        .appraise-view {
            background-color: white;
            margin-bottom: 10px;
            .appraise-title {
                padding: 13px 25px 13px 20px;
                .title {
                    font-size: 14px;
                    font-weight: 800;
                    vertical-align: middle;
                }
                .rate-score {
                    font-size: 14px;
                    color: red;
                    float: right;
                    vertical-align: middle;
                }
                .icon {
                    vertical-align: middle;
                    color: #7c7c7c;
                }
            }
            .appraise-content {
                overflow: auto;
                .box {
                    overflow: hidden;
                }
            }
        }
        .product-view {
            padding: 15px 10px;
            margin-bottom: 10px;
            background-color: white;
            h3 {
                background-color: black;
                text-align: center;
                height: 30px;
                line-height: 30px;
                font-size: 14px;
                color: white;
            }
            h4 {
                line-height: 66px;
                font-size: 16px;
                font-weight: 900;
            }
            table {
                border: 1px solid #bbb;
                // border-collapse: collapse;
                width: 100%;
                font-size: 12px;
                td {
                    border: 1px solid #bbb;
                    height: 38px;
                    line-height: 38px;
                    padding-left: 17px;
                    line-height: 38px;
                }
                td:nth-of-type(1) {
                    width: 87px;
                    color: #707070;
                }
            }
            .product-border {
                border-bottom: 1px solid #bbb;
                p {
                    font-size: 13px;
                }
                img {
                    line-height: 17px;
                    width: 100%;
                }
            }
        }
        .van-goods-action-button--warning {
            background: linear-gradient(to right, #38f9d7, rgb(09, 208, 205));
        }
    }
</style>
